module.exports = __webpack_public_path__ + "media/images/new_home/meal-bg-33bf2541ab46cfe4a9867f241cc5a110.png";